import { type Consumer, createConsumer } from "@rails/actioncable"

let sharedConsumer: Consumer | null = null

/**
 * Returns a shared ActionCable consumer instance.
 * Reuses the same WebSocket connection across all subscriptions.
 */
export function getConsumer(): Consumer {
  if (!sharedConsumer) {
    sharedConsumer = createConsumer("/cable")
  }
  return sharedConsumer
}
